import React from 'react'
import { Container } from '@mui/material'
import Reveal from './Reveal'
import Waves from './Waves'

interface Props {
    title: string
    text: string
    children: React.ReactNode
}

function CtaBand({ title, text, children }: Props) {
    return (
        <section className="ibg-section ibg-section--tight">
            <Container maxWidth="lg">
                <Reveal className="ibg-cta">
                    <Waves />
                    <div className="ibg-cta__text">
                        <h2 className="ibg-h2">{title}</h2>
                        <p>{text}</p>
                    </div>
                    <div className="ibg-actions">{children}</div>
                </Reveal>
            </Container>
        </section>
    )
}

export default CtaBand
